import React from 'react';
import { motion, useInView } from 'framer-motion';
import './AboutSection.css';

const AboutSection = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });

  const edgePoints = [
    { icon: '💪', title: 'Trader Tough', desc: 'Built for the grind—real bulk, real savings, no fluff.' },
    { icon: '📦', title: 'Stock Kings', desc: 'Piles of goods ready to shift—your warehouse away from home.' },
    { icon: '🚛', title: 'Nationwide Hustle', desc: 'From London to Lochs, we deliver the deals.' },
    { icon: '💸', title: 'Price Smashers', desc: 'Cut costs, stack profits—wholesale done right.' },
  ];

  const bulkWins = [
    { label: 'Tonnes Moved', value: 1500, suffix: '+' },
    { label: 'Traders Backed', value: 800, suffix: '+' },
    { label: 'UK Zones Hit', value: 5, suffix: '+' },
    { label: 'Deals Locked', value: 200, suffix: '+' },
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <motion.h2
          className="about-title"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Who We Are
        </motion.h2>

        <motion.div
          className="about-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h3>Bulk Hustle Unleashed</h3>
          <p>
            Launched in 2025, KVP Trade LTD is the new kid on the cash-and-carry block, tearing up West Drayton and beyond. We’re not here to mess about—we’re stacking pallets high with everything from energy drinks to bin bags, all priced to keep your margins fat. This is wholesale with guts, built for traders who live for the deal.
          </p>
        </motion.div>

        <div className="edge-grid" ref={ref}>
          {edgePoints.map((point, index) => (
            <motion.div
              key={index}
              className="edge-card"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              whileHover={{ scale: 1.05 }}
            >
              <span className="edge-icon">{point.icon}</span>
              <h4>{point.title}</h4>
              <p>{point.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="bulk-wins">
          {bulkWins.map((win, index) => (
            <motion.div
              key={index}
              className="win-item"
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.3 }}
            >
              <div className="win-number">{win.value}{win.suffix}</div>
              <div className="win-label">{win.label}</div>
            </motion.div>
          ))}
        </div>

        <motion.a
          href="#shop"
          className="bulk-cta"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          whileHover={{ scale: 1.1, backgroundColor: '#fff176' }}
          whileTap={{ scale: 0.95 }}
        >
          Load Up the Loot
        </motion.a>
      </div>
    </section>
  );
};

export default AboutSection;